import { SmallBusinessApplication } from '@/application/smallBusiness/domain/SmallBusinessApplication';
import { SmallBusinessApplicationApiResponse } from '@/application/smallBusiness/infrastructure/types/SmallBusinessApplicationApiResponse';

export class SmallBusinessApplicationApiAdapter {

  public static async apiResponseToEntity (application: SmallBusinessApplicationApiResponse): Promise<SmallBusinessApplication> {
    return {
      applicants: application.applicants,
      plans: application.plans,
      contribution: application.contribution,
      appointment: application.appointment,
      effective_date: application.effective_date,
      filters: application.filters,
      sample_employee: application.sample_employee,
      detailed_employees: application.detailed_employees,
      company: application.company,
      uuid: application.uuid,
      referenceGroupId: application.agency_bloc_group_id
    };
  }

}
